import {
  getAccount,
  getAccounts,
  getMailboxProviders,
  getSeeds,
} from "@/services";
import { rejectPromise } from "@/utils";
import { formatDateToAmPm } from "@/filters";

/**
 * State of the module
 */
const state = {
  accounts: [],
  seeds: [],
  mailboxProviders: [],
  account: {},
};

/**
 * Mutation constants
 */

const SET_ACCOUNTS = "SET_ACCOUNTS";
const SET_ACCOUNT = "SET_ACCOUNT";
const SET_SEEDS = "SET_SEEDS";
const SET_MAILBOX_PROVIDERS = "SET_MAILBOX_PROVIDERS";

/**
 * Mutations of the module
 */
const mutations = {
  [SET_ACCOUNTS](state, data) {
    state.accounts = data;
  },

  /**
   * SET_SEEDS
   * @param {Array} data - List of all the seeds
   * @description Adds list of the seeds  in the state
   */
  [SET_SEEDS](state, data) {
    return (state.seeds = data);
  },
  [SET_MAILBOX_PROVIDERS](state, data) {
    return (state.mailboxProviders = data);
  },
  [SET_ACCOUNT](state, data) {
    state.account = data;
  },
};

/**
 * Actions of the module
 */
const actions = {
  async getAccounts({ commit }, params = null) {
    try {
      let { data } = await getAccounts(params);

      data = data ?? [];
      commit(SET_ACCOUNTS, data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * * Fetched list of all the account seeds
   * @description Commits a mutation to mutate the seeds list of an account in the state
   */
  async getSeeds({ commit }, params = {}) {
    try {
      let { data } = await getSeeds(params);

      data = data ?? [];
      commit(SET_SEEDS, data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getMailboxProviders({ commit }, params = {}) {
    try {
      let { data } = await getMailboxProviders(params);
      data = data ?? [];

      commit(SET_MAILBOX_PROVIDERS, data);
    } catch (error) {
      rejectPromise(error);
    }
  },
  /**
   * Fetches details of an account
   */
  async getAccount({ commit }, params) {
    try {
      let { data } = await getAccount(params);
      data = data ?? {};
      commit(SET_ACCOUNT, data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

/**
 * Getters of the module
 */
const getters = {
  accounts({ accounts }) {
    return accounts;
  },

  /**
   * Returns the list of all the seeds of an account
   * @returns {Array} List of all the seeds of an account
   */
  seeds({ seeds }) {
    return seeds;
  },
  mailboxProviders({ mailboxProviders }) {
    return mailboxProviders;
  },
  account({ account }) {
    return account;
  },
  filteredSeeds({ seeds }) {
    const mapper = ({ read_at: readAt, failed_at: failedAt, ...seed }) => ({
      read_at: readAt ? formatDateToAmPm(readAt) : readAt,
      failed_at: failedAt ? formatDateToAmPm(failedAt) : failedAt,
      ...seed,
      readAt,
      failedAt,
    });
    return seeds.map(mapper);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
